export const RENTAL_PRICE = "RENTALPRICE";
export const SALES_PRICE = "SALESPRICE";
export const REPLACE_PRICE = "REPLACEPRICE";
export const WASH_PRICE = "WASHPRICE";
export const MIN_USE_PERCENTAGE = "MINUSEPERCENTAGE";
export const RENTAL_QUANTITY = "RENTALQUANTITY";
export const DELIVERY_QUANTITY = "DELIVERYQUANTITY";
export const CIRCULATING_INVENTORY = "CIRCULATINGINVENTORY";
export const CIRCULATION_INVENTORY_MULTIPLIER = "CIRCULATIONINVENTORYMULTIPLIER";
export const DELIVERY_QUANTITY_MULTIPLIER = "DELIVERYQUANTITYMULTIPLIER";
export const RENT_QUANTITY_MULTIPLIER = "RENTQUANTITYMULTIPLIER";
export const DELIVERY_PER_WEEK = "DELIVERYPERWEEK";
export const INVENTORY_MAINTENANCE = "INVENTORYMAINTENANCE";
export const WEEKLY_USAGE = "WEEKLYUSAGE";
